/**
 * Created by liorb on 12/18/2016.
 */
import { DefaultCellHeaderRightAlign } from "app/components/React/Table/headerCells";
import { BasicDurations } from "app/services/DurationService";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

import { PercentPointCell } from "../../../React/Table/cells/PercentPointCell";

export const SimilarSites = {
    id: "SimilarSites",
    properties: {
        component: "WebsiteCompetitors",
        title: "analysis.common.competitors.similar.title",
        family: "Website",
        order: "1",
        keyPrefix: "$",
        state: "digitalsuite_website_websiteperformance",
        forceState: true,
    },
    widgets: {
        single: {
            Table: {
                properties: {},
                columns: [
                    {
                        fixed: true,
                        cellTemp: "index",
                        sortable: false,
                        width: 40,
                        disableHeaderCellHover: true,
                    },
                    {
                        fixed: true,
                        name: "Domain",
                        title: "analysis.competitors.similar.table.columns.domain.title",
                        type: "string",
                        format: "None",
                        sortable: "True",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "website-tooltip-top-cell",
                        tooltip: "analysis.competitors.similar.table.columns.domain.title.tooltip",
                        headTemp: "",
                        totalCount: "True",
                        width: 304,
                    },
                    {
                        name: "Category",
                        title: "analysis.competitors.similar.table.columns.category.title",
                        type: "string",
                        sortable: true,
                        isSorted: false,
                        sortDirection: "desc",
                        groupable: false,
                        cellTemp: "category-filter-cell",
                        tooltip: "analysis.competitors.similar.table.columns.category.title.tooltip",
                        headTemp: "",
                        totalCount: false,
                        isResizable: true,
                        minWidth: 304,
                    },
                    {
                        name: "Rank",
                        title: "analysis.competitors.similar.table.columns.rank.title",
                        type: "long",
                        format: "swRank",
                        sortable: "True",
                        isSorted: "False",
                        sortDirection: "asc",
                        groupable: "False",
                        cellTemp: "rank-cell",
                        tooltip: "analysis.competitors.similar.table.columns.rank.title.tooltip",
                        headerComponent: DefaultCellHeaderRightAlign,
                        totalCount: "False",
                        isResizable: true,
                        minWidth: 108,
                    },
                    {
                        name: "Affinity",
                        title: "analysis.competitors.similar.table.columns.share.title",
                        type: "string",
                        format: "percentagesign",
                        sortable: true,
                        isSorted: true,
                        sortDirection: "desc",
                        groupable: false,
                        cellTemp: "traffic-share",
                        tooltip: "analysis.competitors.similar.table.columns.share.title.tooltip",
                        headerComponent: DefaultCellHeaderRightAlign,
                        totalCount: false,
                        isResizable: true,
                        minWidth: 180,
                    },
                    {
                        name: "HasAdsense",
                        title: "analysis.all.table.columns.googleAds.title",
                        type: "bool",
                        format: "None",
                        sortable: true,
                        isSorted: false,
                        sortDirection: "desc",
                        groupable: false,
                        cellTemp: "adsense-cell",
                        tooltip: "analysis.all.table.columns.googleAds.title.tooltip",
                        headTemp: "",
                        totalCount: false,
                        width: 77,
                    },
                ],
                filters: {
                    orderBy: [
                        {
                            value: "Affinity desc",
                            title: "Affinity",
                        },
                    ],
                },
            },
        },
        compare: {
            Table: {
                properties: {},
                columns: [
                    {
                        fixed: true,
                        cellTemp: "index",
                        sortable: false,
                        width: 65,
                        disableHeaderCellHover: true,
                    },
                    {
                        fixed: true,
                        name: "Domain",
                        title: "analysis.competitors.similar.table.columns.domain.title",
                        type: "string",
                        format: "None",
                        sortable: "True",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "website-tooltip-top-cell",
                        tooltip: "analysis.competitors.similar.table.columns.domain.title.tooltip",
                        headTemp: "",
                        totalCount: "True",
                        width: 173,
                    },
                    {
                        name: "Category",
                        title: "analysis.competitors.similar.table.columns.category.title",
                        type: "string",
                        format: "prettifyCategory",
                        sortable: true,
                        isSorted: false,
                        sortDirection: "desc",
                        groupable: false,
                        cellTemp: "category-filter-cell",
                        tooltip: "analysis.competitors.similar.table.columns.category.title.tooltip",
                        headTemp: "",
                        totalCount: false,
                        minWidth: 150,
                    },
                    {
                        name: "Rank",
                        title: "analysis.competitors.similar.table.columns.rank.title",
                        type: "long",
                        format: "swRank",
                        sortable: "True",
                        isSorted: "False",
                        sortDirection: "asc",
                        groupable: "False",
                        cellTemp: "rank-cell",
                        tooltip: "analysis.competitors.similar.table.columns.rank.title.tooltip",
                        headerComponent: DefaultCellHeaderRightAlign,
                        totalCount: "False",
                        width: 280,
                    },
                    {
                        name: "Affinity",
                        title: "analysis.competitors.similar.table.columns.share.title",
                        type: "string",
                        format: "percentagesign",
                        sortable: true,
                        isSorted: true,
                        sortDirection: "desc",
                        groupable: false,
                        cellTemp: "traffic-share",
                        tooltip: "analysis.competitors.similar.table.columns.share.title.tooltip",
                        headerComponent: DefaultCellHeaderRightAlign,
                        totalCount: false,
                        width: 285,
                    },
                    {
                        name: "HasAdsense",
                        title: "analysis.all.table.columns.googleAds.title",
                        type: "bool",
                        format: "None",
                        sortable: true,
                        isSorted: false,
                        sortDirection: "desc",
                        groupable: false,
                        cellTemp: "adsense-cell",
                        tooltip: "analysis.all.table.columns.googleAds.title.tooltip",
                        headTemp: "",
                        totalCount: false,
                        maxWidth: 120,
                    },
                ],
                filters: {
                    orderBy: [
                        {
                            value: "Affinity desc",
                            title: "Affinity",
                        },
                    ],
                },
            },
        },
    },
};

export const PopularPagesV2 = {
    id: "PopularPagesV2",
    properties: {
        title: "analysis.common.content.pop.pages",
        family: "Website",
        component: "PopularPagesV2",
        hasWebSource: true,
        apiController: "PopularPages",
        order: "1",
        androidOnly: "true",
        state: "digitalsuite_website_popular_v2",
        dashboard: "true",
        viewPermissions: {
            trafficSources: [devicesTypes.TOTAL],
        },
        noCompare: true,
        customFetcherFactory: {
            path: "popularPages.popularPagesFiltersState",
            factoryName: "PopularPagesDataFetcherFactory",
        },
        apiParams: {
            metric: "PopularPages_v2",
        },
        stateParams: {
            selectedTab: "PopularPages",
        },
        mobileWebComponent: "PopularPagesV2",
        availabilityComponent: "PopularPagesV2",
    },
    widgets: {
        single: {
            defaultType: "PopularPagesTable",
            PopularPagesTable: {
                properties: {
                    showMoreButtonItems: 5,
                    options: {
                        showFrame: true,
                        showLegend: false,
                        showOverflow: true,
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
                columns: [
                    {
                        name: "Page",
                        title: "URL",
                        type: "string",
                        format: "None",
                        sortable: false,
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "link-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "analysis.content.pop.pages.table.columns.domain.title.tooltip",
                        minWidth: 300,
                    },
                    {
                        name: "Share",
                        title: "analysis.content.pop.pages.table.columns.share.title",
                        type: "string",
                        format: "smallNumbersPercentage:2",
                        sortable: "False",
                        isSorted: "True",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "default-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "analysis.content.pop.pages.table.columns.share.title.tooltip",
                        width: "115px",
                    },
                    {
                        name: "Change",
                        title: "global.change",
                        type: "double",
                        format: "percentagesign",
                        sortable: true,
                        isSorted: false,
                        sortDirection: "desc",
                        groupable: false,
                        cellComponent: PercentPointCell,
                        totalCount: false,
                        tooltip: "analysis.content.pop.pages.table.columns.change.title.tooltip",
                        width: 110,
                    },
                ],
                filters: {
                    orderBy: [
                        {
                            value: "share",
                            title: "Share",
                        },
                    ],
                },
            },
        },
    },
};

export const TableWebsiteKeywordsDashboard = {
    id: "TableWebsiteKeywordsDashboard",
    properties: {
        dashboard: "true",
        hasWebSource: true,
        title: "dashboard.metricGallery.Website.TableWebsiteKeywordsDashboard.title",
        component: "WebsiteKeywordsV2",
        family: "Website",
        order: "1",
        state: "organicsearch_websites_v2_traffic_keywords",
        apiController: "WebsiteAnalysisV2",
        apiParams: {
            metric: "WebsiteAnalysisOrganic",
        },
        customFetcherFactory: {
            factoryName: "WebsiteKeywordsDataFetcherFactory",
            overrideDashboardFetching: true,
        },
        viewPermissions: {
            trafficSources: [devicesTypes.TOTAL, devicesTypes.DESKTOP, devicesTypes.MOBILE],
        },
        mobileWebComponent: "KeywordAnalysisV2Organic",
        availabilityComponent: "DigitalSuiteAcquisition",
        defaultDuration: BasicDurations.LAST_TWENTY_EIGHT_DAYS,
        showLastOneMonth: true, //if the selected month is the current month, show last 1 month
    },
    widgets: {
        single: {
            defaultType: "TableWebsiteKeywordsDashboard",
            TableWebsiteKeywordsDashboard: {
                properties: {
                    showMoreButtonItems: 5,
                    options: {
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 15,
                        dashboardSubtitleClass: "dashboard-table-widget",
                    },
                },
                columns: [],
            },
        },
        compare: {
            defaultType: "TableWebsiteKeywordsDashboard",
            TableWebsiteKeywordsDashboard: {
                properties: {
                    showMoreButtonItems: 5,
                    options: {},
                },
                columns: [],
            },
        },
    },
};

export const TableLandingPageDashboard = {
    id: "TableLandingPageDashboard",
    properties: {
        dashboard: "true",
        hasWebSource: true,
        title: "dashboard.metricGallery.Website.TableLandingPageDashboard.title",
        component: "OrganicLandingPagesV2",
        family: "Website",
        order: "1",
        state: "organicsearch_website_landingpages_v2",
        noCompare: true,
        apiController: "websiteOrganicLandingPagesV2",
        customFetcherFactory: {
            factoryName: "LandingPagesDataFetcherFactory",
            overrideDashboardFetching: true,
        },
        viewPermissions: {
            trafficSources: [devicesTypes.TOTAL, devicesTypes.DESKTOP, devicesTypes.MOBILE],
        },
        mobileWebComponent: "OrganicLandingPagesV2",
        availabilityComponent: "DigitalSuiteAcquisition",
        defaultDuration: BasicDurations.LAST_TWENTY_EIGHT_DAYS,
        showLastOneMonth: true, //if the selected month is the current month, show last 1 month
    },
    widgets: {
        single: {
            defaultType: "TableLandingPageDashboard",
            TableLandingPageDashboard: {
                properties: {
                    showMoreButtonItems: 5,
                    options: {
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 15,
                        dashboardSubtitleClass: "dashboard-table-widget",
                    },
                },
                columns: [],
            },
        },
    },
};

export const LeadingFolders = {
    id: "LeadingFolders",
    properties: {
        title: "analysis.common.content.pop.folders",
        dashboard: "true",
        hasWebSource: true,
        family: "Website",
        component: "FoldersAnalysis",
        apiController: "LeadingFolders",
        order: "1",
        androidOnly: "true",
        state: "digitalsuite_website_folders",
        stateParams: {
            selectedTab: "Folders",
        },
        noCompare: true,
        viewPermissions: {
            trafficSources: ["Total"],
        },
        availabilityComponent: "FoldersAnalysis",
    },
    widgets: {
        single: {
            defaultType: "LeadingFoldersTable",
            LeadingFoldersTable: {
                properties: {
                    showMoreButtonItems: 5,
                    options: {
                        showLegend: false,
                        dashboardSubtitleMarginBottom: 15,
                    },
                },
                columns: [
                    {
                        name: "Folder",
                        title: "Folder",
                        type: "string",
                        format: "None",
                        sortable: false,
                        isSorted: false,
                        sortDirection: "desc",
                        groupable: false,
                        cellTemp: "link-cell",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: false,
                        width: "",
                    },
                    {
                        name: "Share",
                        title: "analysis.content.pop.pages.table.columns.share.title",
                        type: "string",
                        format: "percentagesign",
                        sortable: false,
                        isSorted: true,
                        sortDirection: "desc",
                        groupable: false,
                        cellTemp: "traffic-share",
                        headTemp: "",
                        totalCount: false,
                        tooltip: "analysis.content.pop.folders.table.columns.share.title.tooltip",
                        minWidth: 300,
                    },
                ],
                filters: {
                    orderBy: [
                        {
                            value: "Share desc",
                            title: "Share",
                        },
                    ],
                },
            },
        },
    },
};

export const SubDomains = {
    id: "SubDomains",
    properties: {
        title: "analysis.common.content.sub.title",
        family: "Website",
        component: "SubDomains",
        order: "1",
        androidOnly: "true",
        state: "digitalsuite_website_websiteperformance",
    },
    widgets: {
        single: {
            Table: {
                properties: {},
                columns: [
                    {
                        // fixed: true,
                        cellTemp: "index",
                        sortable: false,
                        width: 65,
                        disableHeaderCellHover: true,
                    },
                    {
                        name: "Domain",
                        title: "Domain",
                        type: "string",
                        format: "None",
                        sortable: true,
                        isSorted: false,
                        sortDirection: "desc",
                        groupable: false,
                        cellTemp: "website-tooltip-top-cell",
                        headTemp: "",
                        totalCount: true,
                        tooltip: "analysis.content.sub.table.columns.domain.title.tooltip",
                        minWidth: 500,
                    },
                    {
                        name: "Share",
                        title: "Traffic Share",
                        type: "string",
                        format: "percentagesign",
                        sortable: true,
                        isSorted: true,
                        sortDirection: "desc",
                        groupable: false,
                        cellTemp: "traffic-share",
                        headTemp: "",
                        totalCount: false,
                        tooltip: "analysis.content.sub.table.columns.share.title.tooltip",
                        minWidth: 300,
                    },
                ],
                filters: {
                    orderBy: [],
                },
            },
        },
        compare: {
            Table: {
                properties: {},
                columns: [
                    {
                        // fixed: true,
                        cellTemp: "index",
                        sortable: false,
                        width: 65,
                        disableHeaderCellHover: true,
                    },
                    {
                        name: "Domain",
                        title: "Domain",
                        type: "string",
                        format: "None",
                        sortable: "True",
                        isSorted: "False",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "website-tooltip-top-cell",
                        headTemp: "",
                        totalCount: "True",
                        tooltip: "analysis.content.sub.table.columns.domain.title.tooltip",
                        minWidth: 500,
                    },
                    {
                        name: "Share",
                        title: "Traffic Share",
                        type: "string",
                        format: "percentagesign",
                        sortable: "True",
                        isSorted: "True",
                        sortDirection: "desc",
                        groupable: "False",
                        cellTemp: "traffic-share",
                        headTemp: "",
                        totalCount: "False",
                        tooltip: "analysis.content.sub.table.columns.share.title.tooltip",
                        minWidth: 300,
                    },
                ],
                filters: {},
            },
        },
    },
};
